const selectors = {
  productContainer: document.querySelector('.product-details-wrapper'),
  productMedia: document.querySelector('[data-productMedia]')
};

const mediaJSON = JSON.parse(selectors?.productMedia?.innerHTML || null);
window.productMedia = mediaJSON;
class TemplateProductJS {
  constructor() {
    // Custom code for product page goes here
    let time = 0;
    let afterPayInterval = setInterval(() => {
      if (document.querySelector('[data-shipping-info]') != null && document.querySelector('afterpay-placement') != null && document.querySelector('afterpay-placement').innerHTML.length > 20) {
        document.querySelectorAll('[data-shipping-info]').forEach((ele) => {
          ele.classList.remove('d-none')
        })
        clearInterval(afterPayInterval);
      }
      if (time > 6) {
        clearInterval(afterPayInterval)
      }
      time++
    }, 1000)
  }

}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();

const Utils = {};

Utils.openOverlay = () => {
  document.querySelector(".overlay")?.classList.add("show");
  document.querySelector("body")?.classList.add("modal-open");
};

Utils.closeOverlay = () => {
  document.querySelector(".overlay")?.classList.remove("show");
  document.querySelector("body")?.classList.remove("modal-open");
};

class SeeMySize extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const template = document.getElementById("see-my-size-template");
    const templateInstance = template.cloneNode(true);
    const templateContent = templateInstance.content;
    window.defaultScrollEffect = false;

    const seeMySizeData = JSON.parse(this.dataset.seeMySizeData.trim());
    const modelImagesList = templateContent.querySelector(".model-images .swiper-wrapper");
    const modelStep1ImagesList = templateContent.querySelector(".model-size-step-images .swiper-wrapper");
    const modelSwatchImagesList = templateContent.querySelector(".image-swatches");
    const sizesRange = templateContent.querySelector('.sizes-range');
    const descriptionWrapper =
      templateContent.querySelector(".model-description");
    // Size swatches
    const swatchesWrapper = templateContent.querySelector(".swatches-wrapper");
    let container = document.querySelector("[data-selected-product-size]");
    let currentSize = this.dataset.selectedSize || 'S';
    if (container) {
      currentSize = container.getAttribute('data-selected-product-size').trim() || 'S';
    }
    let isSizeAvailableInData = seeMySizeData.find((size) => size.id.toLowerCase() === currentSize.toLowerCase());
    if (!isSizeAvailableInData) {
      currentSize = 'S';
    }
    const selectedSize = currentSize;
    seeMySizeData.forEach((size) => {
      const listItem = document.createElement("li");
      const swatchBtn = document.createElement("button");
      swatchBtn.classList.add('size-selection-btn')
      if (size.id.toUpperCase() === selectedSize.toUpperCase()) {
        swatchBtn.classList.add("selected");
      }
      swatchBtn.innerText = size.id.toUpperCase();
      swatchBtn.dataset.id = size.id.toUpperCase();

      let firstSizeImage = size.images[0];
      let firstSizeDesc = size.description;
      let swatchImageItem = document.createElement("li");
      swatchImageItem.classList.add('size-first-image-container')
      swatchImageItem.setAttribute('id', `list_size_image_${firstSizeImage?.id}`)
      swatchImageItem.classList.add('swiper-slide')
      swatchImageItem.setAttribute('size-name', size.id)
      const modelSwatchImage = document.createElement("img");
      modelSwatchImage.src = `${firstSizeImage?.src}&width=800`;
      modelSwatchImage.alt = firstSizeDesc;
      modelSwatchImage.classList.add('cursor-pointer');
      swatchImageItem.append(modelSwatchImage);
      modelStep1ImagesList.append(swatchImageItem);

      swatchBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        const matchedSize = seeMySizeData.find(
          (sizeInstance) => sizeInstance.id === size.id
        );
        swatchImageItem.querySelectorAll("button").forEach((btn) => {
          btn.classList.remove("selected");
        });
        swatchImageItem
          .querySelector(`button[data-id="${matchedSize.id}"]`)
          .classList.add("selected");
        modelImagesList.scrollLeft = 0;
        modelImagesList.innerHTML = "";
        modelSwatchImagesList.innerHTML = "";
        let counter = 0;
        matchedSize.images.map((image, i) => {
          counter++;
          const listItem = document.createElement("li");
          listItem.setAttribute('id', `list_image_${image.id}`)
          listItem.classList.add('swiper-slide')
          const modelImage = document.createElement("img");
          modelImage.src = `${image.src}&width=800`;
          descriptionWrapper.innerHTML = image.description;
          modelImage.alt = descriptionWrapper.innerHTML;
          if (i == 0) {
            const clickMeButton2 = document.createElement("button");
            clickMeButton2.classList.add("click-me-btn");
            console.log(image)
            const sizeSpan2 = document.createElement("span");
            sizeSpan2.classList.add("size-text");
            sizeSpan2.innerText = size.id.toUpperCase();

            const descSpan2 = document.createElement("span");
            descSpan2.classList.add("desc-text");
            descSpan2.innerText = matchedSize.description;
            clickMeButton2.append(sizeSpan2, descSpan2);
            listItem.append(modelImage, clickMeButton2);
          } else {
            listItem.append(modelImage);
          }

          modelImagesList.append(listItem);
          const swatchListItem = document.createElement("div");
          swatchListItem.classList.add('image-swatch')
          swatchListItem.setAttribute('id', `swatch_image_${image.id}`)
          if (counter === 1) {
            swatchListItem.classList.add('active');
          }
          swatchListItem.addEventListener('click', function () {
            window.defaultScrollEffect = true;
            modelSwatchImagesList.querySelector('.image-swatch.active')?.classList.remove('active')
            swatchListItem.classList.add('active')
            listItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
            setTimeout(() => {
              window.defaultScrollEffect = false;
            }, 500)
          });
          const modelSwatchImage = document.createElement("img");
          modelSwatchImage.src = `${image.src}&width=100`;
          modelSwatchImage.alt = descriptionWrapper.innerHTML;
          swatchListItem.append(modelSwatchImage);
          modelSwatchImagesList.append(swatchListItem);
        });
        this.querySelector('[data-see-size-step-1]')?.classList?.add('d-none');
        this.querySelector('[data-see-size-step-2]')?.classList?.remove('d-none');
        this.querySelector('[data-see-size-mini-swatch]')?.classList?.remove('d-none');
        this.querySelector('[data-see-size-mini-swatch]')?.classList?.add('d-flex');
        this.querySelector('[data-see-size-back]')?.classList?.remove('d-none');
      });
      swatchImageItem.append(swatchBtn);
      swatchImageItem.addEventListener('click', () => {
        swatchBtn.click();
      })
    });
    // Model gallery
    let matchedSize = seeMySizeData.find(
      (size) => size.id.toLowerCase() === selectedSize.toLowerCase()
    );

    // Sizes range
    if (matchedSize) {
      sizesRange.innerText = `${seeMySizeData[0].id.toUpperCase()} - ${seeMySizeData[seeMySizeData.length - 1].id.toUpperCase()}`;

      // Description
      descriptionWrapper.innerText = matchedSize.description;
      let count = 0;
      matchedSize.images.map((image) => {
        count++;
        const listItem = document.createElement("li");
        listItem.setAttribute('id', `list_image_${image.id}`)
        listItem.classList.add('swiper-slide')
        const modelImage = document.createElement("img");
        modelImage.src = `${image.src}&width=800`;
        modelImage.alt = image.description;
        modelImage.setAttribute("loading", "lazy");

        // button created
        const clickMeButton = document.createElement("button");
        clickMeButton.classList.add("click-me-btn");

        const sizeSpan = document.createElement("span");
        sizeSpan.classList.add("size-text");
        sizeSpan.innerText = "XS";

        const descSpan = document.createElement("span");
        descSpan.classList.add("desc-text");
        descSpan.innerText = matchedSize.description;

        clickMeButton.append(sizeSpan, descSpan);
        listItem.append(modelImage, clickMeButton);
        modelImagesList.append(listItem);
        const swatchListItem = document.createElement("div");
        swatchListItem.classList.add('image-swatch')
        if (count === 1) {
          swatchListItem.classList.add('active');
        }
        swatchListItem.setAttribute('id', `swatch_image_${image.id}`)
        swatchListItem.addEventListener('click', function () {
          window.defaultScrollEffect = true;
          modelSwatchImagesList.querySelector('.image-swatch.active')?.classList.remove('active')
          swatchListItem.classList.add('active')
          listItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
          setTimeout(() => {
            window.defaultScrollEffect = false;
          }, 500)
        });
        const modelSwatchImage = document.createElement("img");
        modelSwatchImage.src = `${image.src}&width=100`;
        modelSwatchImage.alt = descriptionWrapper.innerHTML;
        modelSwatchImage.setAttribute("loading", "lazy");
        swatchListItem.append(modelSwatchImage);
        modelSwatchImagesList.append(swatchListItem);
      });

      modelImagesList.addEventListener('scroll', () => {
        modelImagesList.querySelectorAll('li').forEach((modelImageEl, modelImageIndex) => {
          let rect = modelImageEl.getBoundingClientRect();
          let inViewPort = (rect.left >= 0 && rect.left <= 120) ||
            (rect.right <= (window.innerWidth || document.documentElement.clientWidth) + 120);

          if (inViewPort && !window.defaultScrollEffect) {
            let scrollImageId = modelImageEl.getAttribute('id');
            scrollImageId = scrollImageId.replace('list_image_', 'swatch_image_');
            modelSwatchImagesList.querySelector('.image-swatch.active')?.classList.remove('active')
            modelSwatchImagesList.querySelector(`#${scrollImageId}`)?.classList.add('active')
          }
        })
      })

      // Close modal button
      const closeBtn = templateContent.querySelector(".close-btn");
      closeBtn.addEventListener("click", () => {
        this.remove();
        document.querySelector('body').classList.remove('position-fixed-mobile');
        document.body.style.overflowY = "auto";
        Utils.closeOverlay();
      });

      const closeOverlay = document.querySelector(".overlay");
      closeOverlay?.addEventListener("click", () => {
        this.remove();
        document.querySelector('body').classList.remove('position-fixed-mobile');
        document.body.style.overflowY = "auto";
        Utils.closeOverlay();
      });

      this.appendChild(templateContent);
    }

    this.querySelector('[data-see-size-back]')?.addEventListener('click', (e) => {
      this.querySelector('[data-see-size-step-1]')?.classList?.remove('d-none');
      this.querySelector('[data-see-size-step-2]')?.classList?.add('d-none');
      this.querySelector('[data-see-size-mini-swatch]')?.classList?.add('d-none');
      this.querySelector('[data-see-size-mini-swatch]')?.classList?.remove('d-flex');
      this.querySelector('[data-see-size-back]')?.classList?.add('d-none');
    })
  }
}

customElements.define("see-my-size", SeeMySize);

document.addEventListener("click", (event) => {
  const btn = event.target.closest(".see-my-size-btn");
  if (!btn) return;

  event.stopImmediatePropagation();
  const triggerElement = btn.closest('[data-trigger-seemysize]');
  if (!triggerElement) return;

  const type = triggerElement.getAttribute('data-trigger-seemysize');
  // Normalize type name to match the see-my-size-data IDs
  const normalizedType = type.toLowerCase()
    .replace('baller-luxe', 'baller')
    .replace('baller-rib', 'baller')
    .replace('biker-flex', 'biker')
    .replace('baller_padliner', 'baller')
    .replace('baller high waisted', 'baller-high-waisted')
    .replace('biker high waisted', 'biker-high-waisted')
    .replace('star flex', 'star')
    .replace('baller flex', 'baller')
    .replace('ballerhighwaisted_pack', 'baller-high-waisted')
    .replace('bikerhighwaisted_pack', 'biker-high-waisted')
    .replace('ballerpadliner_pack', 'baller')
    .replace('starflex_pack', 'star')
    .replace('ballerflex_pack', 'baller')
    .replace('ballerwim_pack', 'baller')
    .replaceAll('_pack', '');

  const seeMySizeDataElement = document.querySelector(`[data-see-my-size="${normalizedType}"]`);
  const seeMySizeData = seeMySizeDataElement?.innerHTML.trim();

  if (seeMySizeData) {
    const seeMySizeModal = document.createElement("see-my-size");
    seeMySizeModal.dataset.seeMySizeData = seeMySizeData;

    // Check for selected size in both the trigger element and global state
    let container = btn.closest("[data-selected-product-size]");
    if (!container) {
      container = document.querySelector("[data-selected-product-size]");
    }

    if (container) {
      seeMySizeModal.dataset.selectedSize = container.getAttribute('data-selected-product-size').trim();
    }

    document.querySelector("body").prepend(seeMySizeModal);
    document.querySelector('body').classList.add('position-fixed-mobile');
    document.body.style.overflowY = "hidden";
    Utils.openOverlay();

    document.querySelector('[data-see-size-step-1]')?.classList?.remove('d-none');
    document.querySelector('[data-see-size-step-2]')?.classList?.add('d-none');
    document.querySelector('[data-see-size-mini-swatch]')?.classList?.add('d-none');
    document.querySelector('[data-see-size-mini-swatch]')?.classList?.remove('d-flex');
    document.querySelector('[data-see-size-back]')?.classList?.add('d-none');
  }
});
let newMaterial = document.querySelector('[data-enable-material="true"]')
if (newMaterial) {
  document.querySelectorAll('[data-new-material]').forEach((ele) => {
    ele.classList.remove('d-none');
    ele.classList.add('d-flex');
  })
  var htmlObject = {
    'standard': null,
    'highwaisted': null,
    'highsupport': null,
    'ballerfly5': null,
    'ballerfly7': null,
    'baller-highwaisted': null,
    'biker-highwaisted': null,
  }
  var highwaisted = document.querySelector('[data-product-material-type]').getAttribute('data-product-material-type');
  let container = document.querySelector('[data-product-container]');
  if (container.querySelector('[data-support-bar]')) {
    container.querySelector('[data-support-bar] .container_block.active')?.classList?.remove('active');
    container.querySelector(`[data-support-bar] ${highwaisted != "highwaisted" ? '[data-light-container]' : '[data-medium-container]'}`)?.classList?.add('active');
  }
  htmlObject[`${highwaisted}`] = document.querySelector('[data-product-material-type]').innerHTML;

  _fetchHighWaistedProduct();
  async function _fetchHighWaistedProduct() {

    let url = null;
    let url2 = null;
    if (highwaisted == "standard") {
      url = document.querySelector('[data-material_2_url]')?.getAttribute('data-material_2_url')
      url2 = document.querySelector('[data-material_3_url]')?.getAttribute('data-material_3_url')
    } else if (highwaisted == "highwaisted") {
      url = document.querySelector('[data-material_1_url]')?.getAttribute('data-material_1_url')
      url2 = document.querySelector('[data-material_3_url]')?.getAttribute('data-material_3_url')
    } else if (highwaisted == "ballerfly5") {
      url = document.querySelector('[data-material_5_url]')?.getAttribute('data-material_5_url')
    } else if (highwaisted == "ballerfly7") {
      url = document.querySelector('[data-material_4_url]')?.getAttribute('data-material_4_url')
    } else if (highwaisted == "baller-highwaisted") {
      url = document.querySelector('[data-material_7_url]')?.getAttribute('data-material_7_url')
    } else if (highwaisted == "biker-highwaisted") {
      url = document.querySelector('[data-material_6_url]')?.getAttribute('data-material_6_url')
    } else {
      url = document.querySelector('[data-material_1_url]')?.getAttribute('data-material_1_url')
      url2 = document.querySelector('[data-material_2_url]')?.getAttribute('data-material_2_url')
    }
    let response = await fetch(url);
    let data = await response.text();
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(data, 'text/html');
    let isHighwaisted = htmlDocument.querySelector('[data-product-material-type]').getAttribute('data-product-material-type');
    htmlObject[`${isHighwaisted}`] = htmlDocument.querySelector('[data-product-material-type]').innerHTML;

    if (url2) {
      let response2 = await fetch(url2);
      let data2 = await response2.text();
      const parser2 = new DOMParser();
      const htmlDocument2 = parser2.parseFromString(data2, 'text/html');
      let isHighwaisted2 = htmlDocument2.querySelector('[data-product-material-type]').getAttribute('data-product-material-type');
      htmlObject[`${isHighwaisted2}`] = htmlDocument2.querySelector('[data-product-material-type]').innerHTML;
    }
  }

  function _attachEvent() {
    document.querySelectorAll('[data-material]').forEach((ele) => {
      ele.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        let material = ele.getAttribute('data-material');
        let existingMaterial = document.querySelector('[data-material].active').getAttribute('data-material');

        htmlObject[existingMaterial] = document.querySelector('[data-product-material-type]').innerHTML;
        let html = htmlObject[material];
        if (html) {
          let currentForm = document.querySelector('product-form:not(.d-none) [data-product-url].selected').closest('form');
          let selectedSize = currentForm.querySelector('[name="size"]:checked')?.value;
          let purchaseType = currentForm?.querySelector('[data-purchasetype].selected')?.getAttribute('data-purchasetype');
          // let type=currentForm.querySelector('[data-widget-container-wrapper] input:checked').closest('[data-purchasetype]').getAttribute('data-purchasetype')
          document.querySelector('[data-product-material-type]').innerHTML = html;
          _callRebuy();

          //support bar adjustment for boss and icon
          try {
            window.okeWidgetApi?.initAllWidgets();
            let container = document.querySelector('[data-product-container]');
            if (container.querySelector('[data-support-bar]')) {
              container.querySelector('[data-support-bar] .container_block.active')?.classList?.remove('active');
              if (material === 'standard') {
                container.querySelector(`[data-support-bar] [data-light-container]`)?.classList?.add('active');
              } else {
                container.querySelector(`[data-support-bar] [data-medium-container]`)?.classList?.add('active');
              }
            }

            let productDetailsPerks = document.querySelector('.pdp-perks-content');
            if (productDetailsPerks) {
              if (material === 'standard') {
                productDetailsPerks.classList?.add('d-none');
              } else {
                productDetailsPerks.classList?.remove('d-none');
              }
            }

          } catch (e) {
            console.log(e)
          }

          try {
            let url = ele.getAttribute('data-material_url');
            history.pushState(null, null, `${window.location.origin}${url}`);
          } catch (err) {
            console.error(err)
          }
          let newForm = document.querySelector('product-form:not(.d-none) [data-product-url].selected').closest('form');
          newForm.querySelector(`[name="size"][value="${selectedSize}"]`)?.click();

          if (purchaseType != undefined && purchaseType.length != 0 && currentForm.querySelectorAll(`[data-purchasetype]`).length > 1) {
            newForm.querySelector(`[data-purchasetype="${purchaseType}"] label`)?.click();
          }

          document.querySelectorAll('[data-new-material]').forEach((ele) => {
            ele.classList.remove('d-none');
            ele.classList.add('d-flex');
          })
          document.querySelectorAll('[data-modal-opener="new-size-guide-popup"]').forEach((ele) => {
            ele.addEventListener('click', (event) => {
              event.stopImmediatePropagation();
              document.querySelector('#new-size-guide-popup')?.show();
              ele?.manageSizeGuide(ele);
            })
          })
          _attachEvent();
        }
        let currentForm = document.querySelector('product-form:not(.d-none)');
        currentForm.handlePdpImageSlider();
      })
    })
  }
  _attachEvent();
}

// document.querySelectorAll('[href="https://woxer.com/pages/woxer-faq"]').forEach((ele)=>{
//   ele.addEventListener('click',(event)=>{
//     event.preventDefault();
//     document.querySelector('[data-modal-opener="new-size-guide-popup"]').click();
//   })
// })
// PF PDP CHANGES
function _setPdpFaqInCustomBlock() {
  let faqContainer = document.querySelector('#pdp-style-wise-faq');
  if (faqContainer) {
    let productType = faqContainer.querySelector('[product-type]')?.getAttribute('product-type');
    let customContainer = document.querySelector('.pdp-faq-for-padliner');
    if ((productType === 'baller_padliner' || productType === 'ballerpadliner_pack') && customContainer) {
      let section = faqContainer.closest('.shopify-section');
      if (section) {
        customContainer.innerHTML = section.outerHTML; // Use outerHTML to get the HTML string
        section.remove();
      }
    }
  }
}
_setPdpFaqInCustomBlock();
Utils.formatFilterQuery = (filterStr) => {
  const replacements = {
    '"filters":': "filters:",
    '"variantOption"': "variantOption",
    '"name"': "name",
    '"value"': "value",
    "{filters": "filters",
    "]}": "]",
    '"namespace"': "namespace",
    '"key"': "key",
    '"productMetafield"': "productMetafield",
    '"price"': "price",
    '"min":"': "min:",
    '","max":"': ",max:",
    '0"': "0",
    '1"': "1",
    '2"': "2",
    '3"': "3",
    '4"': "4",
    '5"': "5",
    '6"': "6",
    '7"': "7",
    '8"': "8",
    '9"': "9",
    '10"': "10",
  };
  return Object.entries(replacements).reduce(
    (acc, [pattern, replacement]) => acc.replaceAll(pattern, replacement),
    filterStr
  );
};

Utils.setImageUrlWidth = (imageUrl, width) => {
  const newImageUrl = `${imageUrl}&width=${width}`;
  return newImageUrl;
};

Utils.formatMoney = (value) => {
  let cents = value * 100;
  let format = "${{amount}}";
  if (format == null || format == undefined) {
    format = window.globalVariables.money_format || "${{ amount }}";
  }
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value).replace(".00", "");
};

Utils.getOffPercentage = (compareAtPrice, price) => {
  const offPercentage =
    100 - (parseFloat(price) / parseFloat(compareAtPrice)) * 100;
  return Math.round(offPercentage);
};

Utils.formatProductId = (productId) => {
  return productId.replaceAll("gid://shopify/Product/", "");
};

Utils.formatVariantId = (variantId) => {
  return variantId.replaceAll("gid://shopify/ProductVariant/", "");
};

Utils.formatSellingPlanId = (sellingPlanId) => {
  return sellingPlanId.replaceAll("gid://shopify/SellingPlan/", "");
};

Utils.capitalizeStr = (str) => {
  const capitalizeWords = str.replace(/\b\w/g, (letter) =>
    letter.toUpperCase()
  );
  return capitalizeWords;
};

Utils.handleize = (str) => {
  return str
    .toLowerCase()
    .replace(/[^\w\s-]/g, "") // Remove non-word characters, spaces, and hyphens
    .replace(/[\s_-]+/g, "-") // Replace spaces and underscores with hyphens
    .replace(/^-+|-+$/g, ""); // Trim leading and trailing hyphens
};

// GraphQL Query
const useQuery = async (query) => {
  const queryResponse = await fetch("/api/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/graphql",
      "Access-Control-Origin": "*",
      "X-Shopify-Storefront-Access-Token": "919d576e808af70151b52470924f6a99",
    },
    body: query,
  });

  return await queryResponse.json();
};

Utils.addVariantToCart = async (variantId, sellingPlanId = null) => {
  const parsedVariantId = parseInt(variantId);
  const itemObj = {
    id: parsedVariantId,
    quantity: 1,
  };

  if (sellingPlanId) {
    const parsedSellingPlanId = parseInt(sellingPlanId);
    itemObj.properties = {
      _main_subscription: true,
    };
    itemObj.selling_plan = parsedSellingPlanId;
  } else {
    itemObj.properties = {
      _main_subscription: false,
    };
  }
  if (window.customerDetails?.customerTags.includes('Active Subscriber') || window.customerDetails?.customerTags.includes('REAL_ACTIVE_SUBSCRIBER')) {
    itemObj.properties['_active_subscriber'] = true;
  }
  const cartResponse = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: [itemObj],
      sections: `${((window.globalVariables.template == 'cart') ? 'template-cart' : 'component-cart-drawer')},header`
    }),
  });

  let data = await cartResponse.text();
  let dataJSON = ((typeof data == 'object') ? data : JSON.parse(data));
  let cartFormEle = document.querySelector('cart-form');
  if (cartFormEle) {
    cartFormEle._updateCart(dataJSON.sections, 'open_drawer');
  }

  // Remove quickbuys
  document
    .querySelectorAll("quick-buy")
    .forEach((quickBuy) => quickBuy.remove());

  Utils.closeOverlay()

  return await cartResponse.json();
};

Utils.applyOffers = (productTags, productId) => {
  productTags = productTags.split(",");
  let offerApplied = false;
  let customOffers = window.offersJson.enabled_offers;
  let defaultOffer = window.offersJson.default_offer;

  // --------------- Manage Custom offer ---------------
  if (customOffers.length) {
    customOffers.forEach((customOffer) => {
      if (productTags.includes(customOffer.tag) && !offerApplied) {
        let productElements = document.querySelectorAll(
          '[product-id="' + productId + '"]'
        );
        if (productElements.length) {
          productElements.forEach((productElement) => {
            let offerBadge = productElement.querySelector(".offer-badge");
            if (offerBadge) {
              offerBadge.classList.remove("d-none");
              offerBadge.innerHTML = customOffer.label;
              offerBadge.style.color = customOffer.label_color;
              offerBadge.style.backgroundColor = customOffer.label_bg_color;
            }

            let offerTagLine = productElement.querySelector(".offer-tag-line");
            if (offerTagLine) {
              offerTagLine.classList.remove("d-none");
              offerTagLine.classList.add("d-block");
              offerTagLine.innerHTML = customOffer.tag_line;
              offerTagLine.style.color = customOffer.tag_line_color;
            }
          });
        }
        offerApplied = true;
      }
    });
  }

  // --------------- Manage Default offer ---------------
  if (!offerApplied && Object.keys(defaultOffer).length !== 0) {
    let productElements = document.querySelectorAll(
      '[product-id="' + productId + '"]'
    );
    if (productElements) {
      productElements.forEach((productElement) => {
        let offerBadge = productElement.querySelector(".offer-badge");
        const productDetails = JSON.parse(
          productElement.getAttribute("product-details")
        );

        let discount_percentage = Utils.getOffPercentage(
          parseFloat(productDetails.compareAtPriceRange.minVariantPrice.amount),
          parseFloat(productDetails.priceRange.minVariantPrice.amount)
        );

        if (offerBadge && discount_percentage > 0) {
          offerBadge.innerHTML =
            discount_percentage + "% " + defaultOffer.label;
          offerBadge.classList.remove("d-none");

          if (productTags.includes("WSINGLES")) {
            offerBadge.style.color = defaultOffer.singles_label_color;
            offerBadge.style.backgroundColor =
              defaultOffer.singles_label_bg_color;
          } else if (productTags.includes("3PACK")) {
            offerBadge.style.color = defaultOffer.pack_3_label_color;
            offerBadge.style.backgroundColor =
              defaultOffer.pack_3_label_bg_color;
          }

          let offerTagLine = productElement.querySelector(".offer-tag-line");
          if (offerTagLine) {
            offerTagLine.classList.remove("d-none");
            offerTagLine.classList.add("d-block");
            offerTagLine.innerHTML =
              discount_percentage + "% " + defaultOffer.tag_line;
          }
        }
      });
    }
  }
};



Utils.isInViewport = (el, percentVisible) => {
  let rect = el.getBoundingClientRect(),
    windowHeight = window.innerHeight || document.documentElement.clientHeight,
    windowWidth = window.innerWidth || document.documentElement.clientWidth;

  return !(
    Math.floor(100 - ((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100) <
    percentVisible ||
    Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) <
    percentVisible ||
    Math.floor(100 - ((rect.left >= 0 ? 0 : rect.left) / +-rect.width) * 100) <
    percentVisible ||
    Math.floor(100 - ((rect.right - windowWidth) / rect.width) * 100) <
    percentVisible
  );
};

Utils.sortProducts = (products) => {
  products.sort((productA, productB) => {
    let productAOrder = 0;
    let productBOrder = 0;
    if (productA.node.productOrder === null) {
      productAOrder = 999;
    }
    if (productB.node.productOrder === null) {
      productBOrder = 999;
    }

    if (
      productA.node.productOrder !== null &&
      productB.node.productOrder !== null
    ) {
      productAOrder = productA.node.productOrder.value;
      productBOrder = productB.node.productOrder.value;
    }
    return productAOrder - productBOrder;
  });
};

Utils.renderCardPrice = (
  productDetails,
  priceWrapper,
  compareAtPriceValue,
  priceValue
) => {
  priceWrapper.innerHTML = "";
  const isOnSale = compareAtPriceValue > priceValue;
  if (isOnSale) {
    const crossedPriceElement = document.createElement("s");
    crossedPriceElement.classList.add("crossed-price");
    crossedPriceElement.innerText = Utils.formatMoney(compareAtPriceValue);
    priceWrapper.append(crossedPriceElement);

    const salePriceElement = document.createElement("p");
    salePriceElement.classList.add("sale-price");
    salePriceElement.innerText = `${Utils.formatMoney(priceValue)}`;
    priceWrapper.append(salePriceElement);

    const offerTagLineElement = document.createElement("p");
    offerTagLineElement.classList.add(
      "sale-price",
      "offer-tag-line",
      "d-block"
    );
    offerTagLineElement.innerText = `${Utils.getOffPercentage(
      compareAtPriceValue,
      priceValue
    )}% OFF`;
    priceWrapper.append(offerTagLineElement);
  } else {
    const priceElement = document.createElement("p");
    const sellingPlanAllocations =
      productDetails.variants.edges[0].node.sellingPlanAllocations;
    let sellingPlan = null;
    let sellingPlanPrice = 0;
    if (sellingPlanAllocations) {
      sellingPlan = sellingPlanAllocations.edges[0];
      if (sellingPlan) {
        sellingPlanPrice = sellingPlan.node.priceAdjustments[0].price.amount;
      }
    }
    priceElement.innerHTML = `<span class="regular-price">${Utils.formatMoney(
      priceValue
    )}</span>${sellingPlan
      ? `<span class="subscription-price">Subscribers ${Utils.formatMoney(
        sellingPlanPrice
      )}</span>`
      : ""
      }`;
    priceWrapper.append(priceElement);
  }
};

Utils.isMobile = () => {
  const width = window.innerWidth;

  return width <= 769;
};

Utils.updateOfferTaglineCustom = () => {
  try {
    // Check if `window.currentProduct` and `window.currentProduct.product` exist
    if (!window.currentProduct || !window.currentProduct.product) {
      console.warn("window.currentProduct or window.currentProduct.product is not defined.");
      return; // Exit the function if the product data is not available
    }

    if (window.currentProduct.product.tags.includes('PACK')) {
      return;
    }

    // Attempt to select the current product wrapper element
    let currentProductWrapper = document.querySelector(`[data-product-container="${window.currentProduct.product.id}"]`);

    // Fallback to a generic `[data-product-container]` if the specific one is not found
    if (!currentProductWrapper) {
      currentProductWrapper = document.querySelector(`[data-product-container][data-single-product]`);
    }

    // Proceed if a product wrapper was found
    if (currentProductWrapper) {
      const singleCustomOfferTagline = currentProductWrapper.querySelector('.text-left .main-offer');

      // Check if the tagline element exists
      if (singleCustomOfferTagline) {
        // Ensure `currentVariant` exists; default to an empty object if not
        const variant = window.currentProduct.product.currentVariant || {};

        // Ensure `tags` array exists; default to an empty array if not
        const tags = window.currentProduct.product.tags || [];

        // Check if global variables are defined, and use default values if they are not
        const xsDiscountTag = window.globalVariables?.xs_discount_product_tag || '';
        const xsDiscountTagline = window.globalVariables?.xs_discount_tagline || '';

        // Set the tagline based on the variant option and tags
        if (variant.option1 === 'XS' && tags.includes(xsDiscountTag)) {
          singleCustomOfferTagline.innerHTML = `<strong>${xsDiscountTagline}</strong>`;
        } else {
          singleCustomOfferTagline.innerHTML = singleCustomOfferTagline.getAttribute('data-offer-tagline') || '';
        }
      } else {
        console.warn("singleCustomOfferTagline element not found.");
      }
    } else {
      console.warn("currentProductWrapper element not found.");
    }
  } catch (error) {
    console.error("Error in Utils.updateOfferTaglineCustom:", error);
  }
};

Utils.renderQuickBuy = (productCard) => {
  const quickBuy = document.createElement("quick-buy");
  let quickBuyPlusProductSwatch = document.createElement("a");
  const productCardMediaWrapper = productCard.querySelector(".card-img");
  productCardMediaWrapper.append(quickBuy);

  setTimeout(() => {
    const productTagLine = productCard.querySelector(
      ".product-card__price .offer-tag-line"
    );
    if (productTagLine && productTagLine.classList.contains("d-block")) {
      const quickBuyTagLine = productCard.querySelector(
        ".quickbuy-wrapper .offer-tag-line"
      );
      if (quickBuyTagLine) {
        quickBuyTagLine.classList.remove("d-none");
        quickBuyTagLine.classList.add("d-block");
        quickBuyTagLine.innerHTML = productTagLine.innerText;
      }
    }

    const productPlusSwatch = productCard.querySelector(
      ".product-card__swatches-plus"
    );
    if (productPlusSwatch) {
      const quickBuyProductSwatch = productCard.querySelector(
        ".quickbuy-wrapper .quickbuy-options"
      );
      if (quickBuyProductSwatch) {
        quickBuyPlusProductSwatch.setAttribute(
          "href",
          productPlusSwatch.getAttribute("href")
        );
        quickBuyPlusProductSwatch.classList.add("product-card__swatches-plus");
        quickBuyPlusProductSwatch.innerText = productPlusSwatch.innerText;
        quickBuyProductSwatch.append(quickBuyPlusProductSwatch);
      }
    }
  }, 500);
};

Utils.addVideoIcon = (swiperWrapper) => {
  swiperWrapper?.querySelectorAll(".swiper-slide").forEach((slide, index) => {
    const includesVideo = slide.querySelector("custom-video, video");
    if (includesVideo) {
      swiperWrapper
        .querySelectorAll(".swiper-pagination-bullet")
        .forEach((bullet, bulletIndex) => {
          if (index === bulletIndex) {
            bullet.classList.add("video-icon");
          }
        });
    }
  });
};

const productCardImageWidth = 600;

const PRODUCT_SWATCHES_QUERY = `
  query ProductSwatch {
    collection(handle: "{{collection_handle}}") {
      handle
      products(first: 75) {
        edges {
          node {
            id
            title
            handle
            tags
            productType
            priceRange {
              minVariantPrice {
                amount
              }
              maxVariantPrice {
                amount
              }
            }
            featuredImage {
              url
            }
            options {
              name
              values
            }
            variants(first: 1) {
              edges {
                node {
                  sellingPlanAllocations(first: 10) {
                    edges {
                      node {
                        priceAdjustments {
                          price {
                            amount
                            currencyCode
                          }
                          compareAtPrice {
                            amount
                            currencyCode
                          }
                        }
                        sellingPlan {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
            packIcon: metafield(namespace: "custom", key: "pack_icon") {
              reference {
                ... on MediaImage {
                  image {
                    url
                  }
                }
              }
            }
            productOrder: metafield(namespace: "custom", key: "product_order") {
              value
            }
            packThumbnailTagNumber: metafield(namespace: "custom", key: "pack_thumbnail_tag_number") {
              value
            }
            compareAtPriceRange {
              minVariantPrice {
                amount
              }
            }
            images(first: 2) {
              edges {
                node {
                  url
                  altText
                }
              }
            }
          }
        }
      }
    }
  }
  `;

const attachProductColorSwatchEvents = (productColorSwatch) => {
  const swatchBtnTrigger = productColorSwatch.querySelector(".product-swatch");
  swatchBtnTrigger.setAttribute("type", "button");

  swatchBtnTrigger.addEventListener("click", () => {
    const siblingProductDetails = JSON.parse(
      productColorSwatch.getAttribute("sibling-product-details")
    );
    const firstImage = Utils.setImageUrlWidth(
      siblingProductDetails.node.images.edges[0].node.url,
      productCardImageWidth
    );
    const secondImage = Utils.setImageUrlWidth(
      siblingProductDetails.node.images.edges[1].node.url,
      productCardImageWidth
    );
    const productCard = productColorSwatch.closest(
      ".recently-viewed-card, .card-product"
    );

    // Remove active class
    productCard
      .querySelectorAll(".product-swatch__image")
      .forEach((swatchImage) => swatchImage.classList.remove("active"));
    productColorSwatch
      .querySelector(".product-swatch__image")
      .classList.add("active");

    // Update selected ID
    productCard.setAttribute(
      "data-selected-id",
      Utils.formatProductId(siblingProductDetails.node.id)
    );

    // Update title

    productCard.querySelector(".card-title").innerText =
      siblingProductDetails.node.title;

    // Update images
    productCard.querySelector(".card-img img").setAttribute("src", firstImage);
    // productCard
    //     .querySelector(".product-card__second-image")
    //     .setAttribute("src", secondImage);

    // Update product's URL
    productCard
      .querySelectorAll(".product-link, .product-card__swatches-plus")
      .forEach((productCardLink) =>
        productCardLink.setAttribute(
          "href",
          `/products/${siblingProductDetails.node.handle}`
        )
      );

    // Update price
    // Utils.renderCardPrice(
    //     siblingProductDetails.node,
    //     productCard.querySelector(".product-card__price"),
    //     siblingProductDetails.node.compareAtPriceRange.minVariantPrice.amount,
    //     siblingProductDetails.node.priceRange.minVariantPrice.amount
    // );

    // Refresh reviews
    // productCard.querySelector(".okendo-star-rating").setAttribute("data-oke-reviews-product-id", "shopify-"+Utils.formatProductId(siblingProductDetails.node.id));

    const quickBuysOpenCount = Array.from(
      document.querySelectorAll("quick-buy")
    ).length;
    if (quickBuysOpenCount > 0) {
      Utils.renderQuickBuy(productCard);
    }

    productColorSwatch
      .closest(".card-product, .recently-viewed-card")
      .setAttribute(
        "data-selected-id",
        Utils.formatProductId(siblingProductDetails.node.id)
      );
  });
};

class ProductColorSwatch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    const template = document.getElementById("product-color-swatch-template");
    const templateinstance = template;
    const templateContent = templateinstance.content.cloneNode(true);
    const swatchProductDetails = JSON.parse(
      this.getAttribute("sibling-product-details")
    );
    const swatchImageElement = templateContent.querySelector(
      ".product-swatch__image"
    );
    const swatchImageTitle = swatchProductDetails.node.title;

    swatchImageElement.innerHTML = `<span style="display: none;">${swatchImageTitle}</span>`;

    swatchImageElement.style.backgroundImage = `url("${Utils.setImageUrlWidth(
      this.getAttribute("swatch-image"),
      31
    )}")`;
    swatchImageElement.setAttribute("title", swatchImageTitle);

    const productCardId = this.getAttribute("product-card-id");
    const isCurrentCardProduct = productCardId === swatchProductDetails.node.id;

    if (isCurrentCardProduct) {
      swatchImageElement.classList.add("active");
    }

    this.appendChild(templateContent);

    attachProductColorSwatchEvents(this);
  }
}

customElements.define("product-color-swatch", ProductColorSwatch);

const SINGLE_PRODUCT_QUERY = `query Product {
  product(id:"{{product_id}}") {
    id
    title
    handle
    productType
    featuredImage {
      url
      altText
    }
    packIcon: metafield(namespace: "custom", key: "pack_icon") {
      reference {
        ... on MediaImage {
          image {
            url
          }
        }
      }
    }
    okendoStarRating: metafield(namespace: "okendo", key: "StarRatingSnippet") {
      value
    }
    variants(first:100) {
      edges {
        node {
          id
          availableForSale
          selectedOptions {
            name
            value
          }
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
          sellingPlanAllocations(first:1) {
            edges {
              node {
                priceAdjustments {
                  price {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                }
                sellingPlan {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}`;

// Lightbox modal
class Lightbox extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const lightboxElement = this;
    const template = document.getElementById("lightbox-template");
    const templateinstance = template.cloneNode(true);
    const templateContent = templateinstance.content;

    const productMediaData = JSON.parse(this.dataset.productMediaData);
    const mediaWrapper = templateContent.querySelector(
      ".product-media-wrapper"
    );

    const swiperSliderElement = templateContent.querySelector(".swiper-slider");
    const swiperConfig = JSON.parse(swiperSliderElement.dataset.slider);
    const currentMediaIndex = productMediaData.findIndex(
      (media) => media.id === parseInt(this.dataset.selectedMediaId)
    );
    swiperConfig.initialSlide = currentMediaIndex;
    swiperSliderElement.dataset.slider = JSON.stringify(swiperConfig);

    productMediaData.forEach((media) => {
      const swiperSlide = document.createElement("div");
      swiperSlide.classList.add("swiper-slide");
      if (media.media_type === "image") {
        swiperSlide.style.overflow = "hidden";
      }
      let mediaElement;
      if (media.media_type === "image") {
        mediaElement = document.createElement("img");
        mediaElement.src = media.src.replaceAll("width=750", "width=2000");
        mediaElement.alt = media.alt;
        mediaElement.dataset.action = "zoom";
        mediaElement.title = media.alt;
      } else {
        swiperSlide.innerHTML = `<button class="play__btn" type="button">
        <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.9092 8.69528C13.451 9.09497 13.451 9.90503 12.9092 10.3047L2.09366 18.2836C1.43346 18.7707 0.499999 18.2993 0.499999 17.4789L0.5 1.52111C0.5 0.700699 1.43346 0.229346 2.09366 0.71639L12.9092 8.69528Z" fill="black"/>
        </svg>
        </button>`;

        mediaElement = document.createElement("video");
        mediaElement.poster = media.preview_image;
        mediaElement.src = media.source;

        swiperSlide
          .querySelector(".play__btn")
          .addEventListener("click", function () {
            mediaElement.setAttribute("controls", "");
            mediaElement.play();
            mediaElement.style.display = 'inline-block';
            this.style.display = "none";
          });
      }

      swiperSlide.append(mediaElement);
      mediaWrapper.append(swiperSlide);
    });

    setTimeout(() => {
      Utils.addVideoIcon(swiperSliderElement);
    }, 500);

    templateContent
      .querySelectorAll('img[data-action="zoom"]')
      .forEach((img) => {
        let initialTouchPos = null;

        img.addEventListener("click", function (e) {
          const swiperContainer = img.closest(".swiper");
          const swiperInstance = swiperContainer.swiper;
          if (this.classList.contains("zoomed")) {
            this.style.transform = "";
            this.classList.remove("zoomed");
            this.classList.remove("zoomed-in");
            this.setAttribute('style', '');
            swiperInstance.allowTouchMove = true;
            document.querySelectorAll('.lightbox-close, .swiper-button-next, .swiper-button-prev').forEach(element => element.setAttribute('style', ''));
            swiperSliderElement.classList.remove('zoom-enabled');
          } else {
            swiperSliderElement.classList.add('zoom-enabled');
            const rect = this.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / this.offsetWidth) * 100;
            const y = ((e.clientY - rect.top) / this.offsetHeight) * 100;
            this.style.objectPosition = `${x}% ${y}%`;
            if (Utils.isMobile()) {
              this.style.transform = "scale(0.8)";
            } else {
              this.style.transform = "scale(1)";
            }
            this.style.transformOrigin = `${x}% ${y}%`;

            // Increase the image size to almost the full width and height of the viewport, but without deforming the image.
            this.style.maxHeight = `${window.innerHeight - 20}px`;
            this.style.maxWidth = `${window.innerWidth - 20}px`;

            // Make the image responsive by setting the width and height to auto.
            this.style.width = "auto";
            this.style.height = "auto";

            this.classList.add("zoomed");
            this.classList.add("zoomed-in");
            swiperInstance.allowTouchMove = false;
            document.querySelectorAll('.lightbox-close, .swiper-button-next, .swiper-button-prev').forEach(element => element.style.display = 'none');
          }
        });

        img.addEventListener("mousemove", function (e) {
          if (this.classList.contains("zoomed")) {
            const rect = this.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / this.offsetWidth) * 100;
            const y = ((e.clientY - rect.top) / this.offsetHeight) * 100;
            this.style.objectPosition = `${x}% ${y}%`;
          }
        });

        img.addEventListener("mouseleave", function () {
          if (this.classList.contains("zoomed-in")) {
            this.style.objectPosition = "center";
            this.classList.remove("zoomed-in");
          }
        });

        // Add a touchmove event listener to move the focus point of the zoom as you swipe the image with your fingers on mobile.
        img.addEventListener("touchstart", function (e) {
          if (this.classList.contains("zoomed")) {
            initialTouchPos = { x: e.touches[0].clientX, y: e.touches[0].clientY };
          }
        });

        img.addEventListener("touchmove", function (e) {
          if (this.classList.contains("zoomed") && initialTouchPos !== null) {
            let deltaX = e.touches[0].clientX - initialTouchPos.x;
            let deltaY = e.touches[0].clientY - initialTouchPos.y;

            let currentObjectPosition = getComputedStyle(this).objectPosition.split(' ');
            let currentXPercentage = parseFloat(currentObjectPosition[0]);
            let currentYPercentage = parseFloat(currentObjectPosition[1]);

            let newXPercentage = currentXPercentage - deltaX / window.innerWidth * 100;
            let newYPercentage = currentYPercentage - deltaY / window.innerHeight * 100;

            newXPercentage = Math.max(0, Math.min(newXPercentage, 100));
            newYPercentage = Math.max(0, Math.min(newYPercentage, 100));

            this.style.objectPosition = `${newXPercentage}% ${newYPercentage}%`;

            initialTouchPos.x += deltaX;
            initialTouchPos.y += deltaY;
          }
        });
      });

    Utils.openOverlay();

    templateContent
      .querySelector(".lightbox-close")
      .addEventListener("click", function () {
        lightboxElement.remove();
        Utils.closeOverlay();
      });

    this.appendChild(templateContent);
  }
}

customElements.define("lightbox-modal", Lightbox);

const lightboxTriggers = document.querySelectorAll(".lightbox-trigger");
lightboxTriggers.forEach((lightboxTrigger) => {
  lightboxTrigger.addEventListener("click", () => {
    // Get most recent data
    const productMediaData = document
      .getElementById("lightbox-data")
      .innerHTML.trim();
    const lightbox = document.createElement("lightbox-modal");
    lightbox.dataset.selectedMediaId = lightboxTrigger.dataset.mediaId;
    lightbox.dataset.productMediaData = productMediaData;
    document.querySelector("body").append(lightbox);
  });
});

// Recommended products cards JS
document.querySelectorAll(".card-product").forEach((card) => {
  const productSwatches = card.querySelectorAll(".product-swatch");
  productSwatches.forEach((productSwatch) => {
    productSwatch.addEventListener("click", () => {
      const productDetails = {
        title: productSwatch.getAttribute("title"),
        firstImageSrc: productSwatch.dataset.firstImage.replaceAll(
          "127.0.0.1:9292",
          "woxer.com"
        ),
        url: productSwatch.dataset.url,
        priceHtml: productSwatch.dataset.priceHtml,
        id: productSwatch.dataset.selectedId,
      };

      const productCardWrapper = productSwatch.closest(".card-product");
      // Update product URLs
      productCardWrapper
        .querySelectorAll(".product-link")
        .forEach((link) => (link.href = productDetails.url));
      // Update image
      const firstImg = productCardWrapper.querySelector(".card-img img");
      firstImg.src = productDetails.firstImageSrc;
      firstImg.srcset = productDetails.firstImageSrc;
      // Update title
      const productCardTitle = productCardWrapper.querySelector(
        ".card-title .product-link"
      );
      productCardTitle.innerText = productDetails.title;
      productCardTitle.dataset.linkText = productDetails.title;
      // Update id
      productCardWrapper.dataset.selectedId = productDetails.id;

      // Update price
      const priceWrapper = productCardWrapper.querySelector(
        ".price-card-wrapper"
      );
      priceWrapper.innerHTML = productDetails.priceHtml;
      document
        .querySelectorAll(".product-swatch")
        .forEach((swatch) => swatch.classList.remove("active"));
      productSwatch.classList.add("active");
    });
  });
});

// Quickbuy

var collectionsJson = {};
var productsJson = {};

class QuickBuy extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const quickBuyElement = this;
    const template = document.getElementById("quickbuy-template");
    const templateinstance = template.cloneNode(true);
    const templateContent = templateinstance.content;

    const productId = this.closest(".card-product, .recently-viewed-card")
      .dataset.selectedId;
    const productQuery = SINGLE_PRODUCT_QUERY.replaceAll(
      "{{product_id}}",
      `gid://shopify/Product/${productId}`
    );
    var productData = productsJson[productId];
    if (!productData) {
      productData = await useQuery(productQuery);
      productsJson[productId] = productData;
    }
    const productVariants = productData.data.product.variants.edges;

    const sizeValues = productVariants.map((variant) => {
      const sizeOption = variant.node.selectedOptions.find((option) =>
        option.name.includes("Size")
      );
      return {
        variantId: Utils.formatVariantId(variant.node.id),
        value: sizeOption.value,
        available: variant.node.availableForSale
      };
    });

    // Close other quickbuys
    document.querySelectorAll("quick-buy").forEach(function (quickBuyInstance) {
      if (quickBuyInstance.isEqualNode(quickBuyElement) === false) {
        quickBuyInstance.remove();
      }
    });

    const quickBuyImage = templateContent.querySelector(
      ".quickbuy-product-image"
    );
    quickBuyImage.setAttribute(
      "src",
      Utils.setImageUrlWidth(productData.data.product.featuredImage.url, 200)
    );
    quickBuyImage.setAttribute(
      "alt",
      productData.data.product.featuredImage.altText
    );
    templateContent.querySelector(".quickbuy-product-title").innerText =
      productData.data.product.title;

    templateContent.querySelector(
      ".quickbuy-atc"
    ).innerText = `Add to Bag - ${Utils.formatMoney(
      productVariants[0].node.price.amount
    )}`;

    templateContent.querySelector(
      ".quickbuy-atc"
    ).setAttribute("data-link-subcategory", `${productData.data.product.title}`);

    console.log(sizeValues, 'sizeValues')
    sizeValues.forEach((size) => {
      if (size.available) {
        const sizesWrapper = templateContent.querySelector(
          ".quickbuy-options.size"
        );
        const sizeItem = document.createElement("li");
        let dataLinkCategory = 'PDPS';
        if (productData.data.product.title.includes("-Pack")) {
          dataLinkCategory = 'PDPP'
        }
        sizeItem.innerHTML = `<button class="${!size.available ? 'd-none' : ''}" data-link-category="${dataLinkCategory} ProductSuggestion" data-link-subcategory="${productData.data.product.title} SizeSelect" data-link-text="${size.value}" data-variant-id="${size.variantId}" data-option-name="${size.value}" type="button">${size.value}</button>`;
        sizesWrapper.append(sizeItem);
      }
    });

    const firstVariantPlanAllocations =
      productData.data.product.variants.edges[0].node.sellingPlanAllocations
        .edges;
    if (firstVariantPlanAllocations.length === 0) {
      templateContent.querySelector(".subscribe_save_price").style.display =
        "none";
    } else {
      const planAllocation = firstVariantPlanAllocations[0].node;
      const planCompareAtPrice =
        planAllocation.priceAdjustments[0].compareAtPrice.amount;
      const planPrice = planAllocation.priceAdjustments[0].price.amount;

      templateContent.querySelector(
        "[data-subscription-price]"
      ).innerHTML = `<span class="subscription-amount">${Utils.formatMoney(
        planPrice
      )}</span> for Subscribers`;
      templateContent.querySelector(
        "[data-subscription-percentage]"
      ).innerText = `${Utils.getOffPercentage(
        planCompareAtPrice,
        planPrice
      )}% OFF`;
    }

    templateContent.querySelector(
      ".subscribe_save_price input"
    ).id = `switch-${productId}`;
    templateContent
      .querySelector(".subscribe_save_price label")
      .setAttribute("for", `switch-${productId}`);

    this.setAttribute("variants", JSON.stringify(productVariants));
    this.setAttribute("product-handle", productData.data.product.handle);

    // Build quickbuy color swatches
    const productCard = this.closest(".card-product, recently-viewed-card");
    let collectionHandle = productCard.dataset.collectionHandle;
    var siblingProducts = collectionsJson[collectionHandle];
    if (!siblingProducts) {
      siblingProducts = await useQuery(
        PRODUCT_SWATCHES_QUERY.replaceAll(
          "{{collection_handle}}",
          collectionHandle.replaceAll('_', '-').replace('mix-pack', 'mixpack')
        )
      );
      collectionsJson[collectionHandle] = siblingProducts;
    }
    siblingProducts = siblingProducts.data.collection?.products?.edges;

    /* -------------- filter pack products ---------------- */
    let productPackSize = productCard.getAttribute("product-pack-size");
    productPackSize = productPackSize.length !== 0 ? productPackSize : false;

    // Sort the array
    let quickBuyProductID = productCard.getAttribute("product-id");
    siblingProducts.sort((a, b) => {
      if (a.node.id === quickBuyProductID) return -1; // "a" comes first
      if (b.node.id === quickBuyProductID) return 1; // "b" comes first
      return 0; // No change in order
    });

    let slicedSiblingProducts;
    slicedSiblingProducts = siblingProducts.slice(0, 5);

    const colorSwatchesWrapper = templateContent.querySelector(
      ".quickbuy-options.color"
    );
    slicedSiblingProducts.forEach((siblingProduct) => {
      if (siblingProduct.node.productType == productCard.getAttribute('data-product-type')) {
        const colorSwatch = document.createElement("product-color-swatch");
        colorSwatch.setAttribute(
          "sibling-product-details",
          JSON.stringify(siblingProduct)
        );

        let swatchImage = "";
        if (siblingProduct.node.packIcon) {
          swatchImage = siblingProduct.node.packIcon.reference.image.url;
        } else if (siblingProduct.node.featuredImage) {
          swatchImage = siblingProduct.node.featuredImage.url;
        }

        colorSwatch.setAttribute("swatch-image", swatchImage);

        const siblingProductId = Utils.formatProductId(siblingProduct.node.id);
        if (siblingProductId == productId) {
          colorSwatch.classList.add("active");
          const colorOptionObj = siblingProduct.node.options.find(
            (option) => option.name === "Color"
          );
          templateContent.querySelector("[data-current-color]").innerText =
            colorOptionObj.values[0];
        } else {
          colorSwatch.classList.remove("active");
        }
        colorSwatch.setAttribute("sibling-product-id", siblingProductId);
        colorSwatchesWrapper.append(colorSwatch);
      }
    });

    // render quickbuy top price
    const selectedSizeSwatch = document.querySelector(
      ".quickbuy-options li button.active"
    );
    let compareAtPrice = 0;
    let price = 0;
    if (selectedSizeSwatch) {
      const selectedVariantId = parseInt(selectedSizeSwatch.dataset.variantId);
      const matchedVariant = productData.data.product.variants.edges.find(
        (variant) => variant.id.includes(selectedVariantId)
      );
      compareAtPrice = matchedVariant.compareAtPrice.amount;
      price = matchedVariant.price.amount;
    } else {
      const matchedVariant = productData.data.product.variants.edges[0];
      price = matchedVariant.node.price.amount;
      compareAtPrice = matchedVariant.node.compareAtPrice.amount;
    }
    const priceWrapper = templateContent.querySelector(
      ".quickbuy-product-price"
    );
    Utils.renderCardPrice(
      productData.data.product,
      priceWrapper,
      compareAtPrice,
      price
    );

    this.appendChild(templateContent);

    attachQuickBuyEvents(this);
  }
}

customElements.define("quick-buy", QuickBuy);

attachQuickBuyEvents = (quickBuy) => {
  const quickbuyAtcBtn = quickBuy.querySelector(".quickbuy-atc");
  const variants = JSON.parse(quickBuy.getAttribute("variants"));
  let selectedVariantId = quickBuy.dataset.selectedVariantId;
  const quickbuySubscriptionCheckbox = document.querySelector(
    ".subscribe_save_price input"
  );

  quickbuyAtcBtn.addEventListener("click", async (event) => {
    event.preventDefault();
    if (selectedVariantId) {
      quickbuyAtcBtn.innerText = "Adding";
      const matchedVariant = variants.find(
        (variant) =>
          parseInt(Utils.formatVariantId(variant.node.id)) ===
          parseInt(Utils.formatVariantId(selectedVariantId))
      );
      const sellingPlanAllocations =
        matchedVariant.node.sellingPlanAllocations.edges;
      const subscriptionEnabled = quickBuy.querySelector(
        ".subscribe_save_price input"
      ).checked;
      if (sellingPlanAllocations.length > 0 && subscriptionEnabled) {
        const sellingPlanId = parseInt(
          Utils.formatSellingPlanId(
            sellingPlanAllocations[0].node.sellingPlan.id
          )
        );
        await Utils.addVariantToCart(selectedVariantId, sellingPlanId);
      } else {
        await Utils.addVariantToCart(selectedVariantId);
      }
      quickbuyAtcBtn.innerText = "Added!";
      setTimeout(() => {
        quickBuy.remove();
      }, 500);
    } else {
      const matchedVariant = variants.find(
        (variant) =>
          parseInt(Utils.formatVariantId(variant.node.id)) ===
          parseInt(
            selectedVariantId || Utils.formatVariantId(variants[0].node.id)
          )
      );
      let variantPrice = 0;
      if (quickbuySubscriptionCheckbox.checked) {
        const sellingPlanAllocation =
          matchedVariant.node.sellingPlanAllocations.edges[0].node;
        variantPrice = sellingPlanAllocation.priceAdjustments[0].price.amount;
      } else {
        variantPrice = matchedVariant.node.price.amount;
      }
      quickbuyAtcBtn.classList.add("btn-warning");

      quickbuyAtcBtn.innerText = `Select size - ${Utils.formatMoney(
        variantPrice
      )}`;
      setTimeout(() => {
        quickbuyAtcBtn.innerText = `Add to bag - ${Utils.formatMoney(
          variantPrice
        )}`;
        quickbuyAtcBtn.classList.remove("btn-warning");
      }, 1000);
    }
  });

  const sizeGuideBtn = quickBuy.querySelector(".size-guide-trigger");
  sizeGuideBtn.addEventListener("click", (event) => {
    event.preventDefault();
    document
      .querySelector("#new-size-guide-popup .modal")
      .classList.add("open");
  });

  // Option swatches
  const quickBuyOptions = quickBuy.querySelectorAll(
    ".quickbuy-options.size button"
  );
  quickBuyOptions.forEach((optionBtn) => {
    optionBtn.addEventListener("click", () => {
      quickBuyOptions.forEach((btn) => btn.classList.remove("active"));
      quickBuy.dataset.selectedVariantId = Utils.formatVariantId(
        optionBtn.dataset.variantId
      );
      optionBtn.classList.add("active");

      selectedVariantId = quickBuy.dataset.selectedVariantId;

      // Change ATC button label
      const matchedVariant = variants.find(
        (variant) =>
          parseInt(Utils.formatVariantId(variant.node.id)) ===
          parseInt(
            selectedVariantId || Utils.formatVariantId(variants[0].node.id)
          )
      );
      let variantPrice = 0;
      if (quickbuySubscriptionCheckbox.checked) {
        const sellingPlanAllocation =
          matchedVariant.node.sellingPlanAllocations.edges[0].node;
        variantPrice = sellingPlanAllocation.priceAdjustments[0].price.amount;
      } else {
        variantPrice = matchedVariant.node.price.amount;
      }
      quickbuyAtcBtn.innerText = `Add to Bag - ${Utils.formatMoney(
        variantPrice
      )}`;
    });
  });

  const quickbuySubscriptionlabel = document.querySelector(
    ".subscribe_save_price label"
  );
  document
    .querySelector(".subscribe_save_price input")
    .addEventListener("change", function () {
      const matchedVariant = variants.find(
        (variant) =>
          parseInt(Utils.formatVariantId(variant.node.id)) ===
          parseInt(
            selectedVariantId || Utils.formatVariantId(variants[0].node.id)
          )
      );
      if (this.checked) {
        const sellingPlanAllocation =
          matchedVariant.node.sellingPlanAllocations.edges[0].node;
        const sellingPlanPrice =
          sellingPlanAllocation.priceAdjustments[0].price.amount;
        quickbuyAtcBtn.innerText = `Add to Bag - ${Utils.formatMoney(
          sellingPlanPrice
        )}`;

        quickbuyAtcBtn.setAttribute("data-link-text", "Add To Subscription");
        quickbuySubscriptionlabel.setAttribute("data-link-text", "One-time Purchase");
      } else {
        quickbuyAtcBtn.innerText = `Add to Bag - ${Utils.formatMoney(
          matchedVariant.node.price.amount
        )}`;
        quickbuyAtcBtn.setAttribute("data-link-text", "Add To Bag");
        quickbuySubscriptionlabel.setAttribute("data-link-text", "Subscribe & Save");
      }
    });

  const quickBuyCloseBtn = quickBuy.querySelector(".quickbuy-close");
  quickBuyCloseBtn.addEventListener("click", () => {
    quickBuy.remove();
    Utils.closeOverlay();
  });

  // Close quickbuy on mouseleave
  if (!Utils.isMobile()) {
    quickBuy.addEventListener("mouseleave", () => {
      quickBuy.remove();
    });
  }
};

// Quick buy
const quickAddTriggers = document.querySelectorAll(
  ".product-card__quickadd-btn"
);

quickAddTriggers.forEach((quickAddTrigger) => {
  quickAddTrigger.addEventListener("click", () => {
    const productCard = quickAddTrigger.closest(".card-product");
    Utils.renderQuickBuy(productCard);
    if (Utils.isMobile()) {
      Utils.openOverlay();
    }
  });
});

// Related products section
const relatedProductsWrapper = document.querySelectorAll(
  ".section-related-products"
);
relatedProductsWrapper.forEach(wrapper => {
  const relatedProdPrevBtn = wrapper?.querySelector(
    ".slider-nav-btn[data-prev-button]"
  );
  const relatedProdNextBtn = wrapper?.querySelector(
    ".slider-nav-btn[data-next-button]"
  );

  relatedProdPrevBtn?.addEventListener("click", () => {
    wrapper?.querySelector(".swiper-button-prev")?.click();
  });

  relatedProdNextBtn?.addEventListener("click", () => {
    wrapper?.querySelector(".swiper-button-next")?.click();
  });
})
// Same color products section

const sameColorProductsWrapper = document.querySelector(
  ".section-same-color-products"
);
const sameColorProdPrevBtn = sameColorProductsWrapper?.querySelector(
  ".slider-nav-btn[data-prev-button]"
);
const sameColorProdNextBtn = sameColorProductsWrapper?.querySelector(
  ".slider-nav-btn[data-next-button]"
);

sameColorProdPrevBtn?.addEventListener("click", () => {
  sameColorProductsWrapper?.querySelector(".swiper-button-prev")?.click();
});

sameColorProdNextBtn?.addEventListener("click", () => {
  sameColorProductsWrapper?.querySelector(".swiper-button-next")?.click();
});

// Collection products section
const collectionProductsWrapper = document.querySelector(
  ".collection-product-slider .section-related-products"
);
const collectionProdPrevBtn = collectionProductsWrapper?.querySelector(
  ".slider-nav-btn[data-prev-button]"
);
const collectionProdNextBtn = collectionProductsWrapper?.querySelector(
  ".slider-nav-btn[data-next-button]"
);

collectionProdPrevBtn?.addEventListener("click", () => {
  collectionProductsWrapper?.querySelector(".swiper-button-prev")?.click();
});

collectionProdNextBtn?.addEventListener("click", () => {
  collectionProductsWrapper?.querySelector(".swiper-button-next")?.click();
});

// Secondary reviews section
const secondaryReviewsWrapper = document.querySelector(
  ".secondary-product-reviews"
);
const prevBtn = secondaryReviewsWrapper?.querySelector(
  ".slider-nav-btn[data-prev-button]"
);
const nextBtn = secondaryReviewsWrapper?.querySelector(
  ".slider-nav-btn[data-next-button]"
);

prevBtn?.addEventListener("click", () => {
  secondaryReviewsWrapper.querySelector(".swiper-button-prev").click();
});

nextBtn?.addEventListener("click", () => {
  secondaryReviewsWrapper.querySelector(".swiper-button-next").click();
});

function addWeekdays(startDate, days) {
  const date = new Date(startDate);
  let added = 0;

  while (added < days) {
    date.setDate(date.getDate() + 1);
    const day = date.getDay(); // 0=Sun, 6=Sat
    if (day !== 0 && day !== 6) {
      added++;
    }
  }

  return date;
}

function formatDate(date) {
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric'
  });
}

// MAIN
try {
  const today = new Date();
  const startDate = addWeekdays(today, 5); // 5 weekdays from today
  const endDate = addWeekdays(today, 7);   // 7 weekdays from today

  if (document.querySelector('.estimated_delivery_container .estimated_date')) {
    document.querySelector('.estimated_delivery_container .estimated_date').textContent = `${formatDate(startDate)} - ${formatDate(endDate)}`;
  }
} catch (e) {
  console.log(e)
}

// Recently viewed products
const getRecentlyViewedProducts = () => {
  let viewedProducts = [];
  const localData = localStorage.getItem("recently_viewed_products");
  if (localData) {
    viewedProducts = JSON.parse(localData);
  }
  return viewedProducts;
};

const addRecentlyViewedProduct = (productId) => {
  let viewedProducts = getRecentlyViewedProducts();
  const index = viewedProducts.indexOf(productId);
  if (index > -1) {
    viewedProducts.splice(index, 1);
  }
  viewedProducts.unshift(productId);
  if (viewedProducts.length > 10) {
    viewedProducts = viewedProducts.slice(0, 10);
  }
  localStorage.setItem(
    "recently_viewed_products",
    JSON.stringify(viewedProducts)
  );
};

// document.querySelectorAll(".variant-size.unavailable .form-label").forEach((sizeSwatch) => {
//   sizeSwatch.addEventListener("click", () => {

//     document.querySelectorAll(".variant-size.unavailable .form-label").forEach((sizeSwatch) => {
//       sizeSwatch.classList.remove('swatch-selected');
//     });

//     document.querySelectorAll("[data-oos-modal] select.form-control option")
//       .forEach((option) => {
//         const optionValue = option.innerText.toUpperCase().trim();
//         if (optionValue === sizeSwatch.title) {
//           option.selected = true;
//         } else {
//           option.selected = false;
//         }
//       });
//     sizeSwatch.classList.add('swatch-selected');
//   });
// });

document.querySelectorAll(".variant-size .form-label").forEach((sizeSwatch) => {
  sizeSwatch.addEventListener("click", (event) => {
    let container = event.target.closest("[data-selected-product-size]");
    if (container) {
      container.setAttribute('data-selected-product-size', sizeSwatch.innerText);
    }

    let stickyContainer = container.querySelector("[data-sticky-atc]");
    if (stickyContainer) {
      stickyContainer.querySelector('.size-title').innerText = sizeSwatch.innerText.toString().replace(/(\r\n|\n|\r)/gm, "");
      stickyContainer.querySelector('.size-separator').classList.remove('d-none');
      stickyContainer.querySelector('.size-menu')?.classList.toggle('d-none');
    }
    document
      .querySelectorAll(".form-color-swatch-wrapper")
      .forEach((colorSwatch) => {
        if (!colorSwatch.dataset.variants) {
          console.log(colorSwatch);
        }
        const variants = JSON.parse(colorSwatch.dataset.variants);
        const matchedVariant = variants.find(
          (variant) =>
            variant.option1.toLowerCase() === sizeSwatch.innerText.toLowerCase()
        );
        if (matchedVariant && !matchedVariant.available) {
          colorSwatch.classList.add("sold-out");
        } else {
          colorSwatch.classList.remove("sold-out");
        }
      });
  });
});

document.querySelectorAll(".pdp-size-selector-ab [data-single_size]").forEach((ele) => {
  ele.addEventListener("click", (event) => {
    let container = event.target.closest("[data-selected-product-size]");
    let sizeValue = ele.closest('[data-single_size]')?.getAttribute('data-single_size')?.toLowerCase();
    container?.setAttribute('data-selected-product-size', sizeValue);

    let stickyContainer = container.querySelector("[data-sticky-atc]");
    if (stickyContainer) {
      stickyContainer.querySelector('.size-title').innerText = sizeValue?.toString()?.replace(/(\r\n|\n|\r)/gm, "");
      stickyContainer.querySelector('.size-separator').classList.remove('d-none');
      stickyContainer.querySelector('.size-menu')?.classList.toggle('d-none');
    }
    document
      .querySelectorAll(".form-color-swatch-wrapper")
      .forEach((colorSwatch) => {
        if (!colorSwatch.dataset.variants) {
          console.log(colorSwatch);
        }
        const variants = JSON.parse(colorSwatch.dataset.variants);
        const matchedVariant = variants.find(
          (variant) =>
            variant.option1.toLowerCase() === sizeValue.toLowerCase()
        );
        if (matchedVariant && !matchedVariant.available) {
          colorSwatch.classList.add("sold-out");
        } else {
          colorSwatch.classList.remove("sold-out");
        }
      });
  });
});

// Add play icon mobile slider
Utils.addVideoIcon(document.querySelector("[data-mobile-product-slider]"));

document.querySelector('.overlay')?.addEventListener('click', () => {
  Utils.closeOverlay();
  document.querySelectorAll('see-my-size, quick-buy, lightbox-modal').forEach(element => element.remove());
});

// Autoplay video on page load
document.addEventListener('DOMContentLoaded', () => {
  if (!Utils.isMobile()) {
    const videoWrapper = document.querySelector('.product-images-listing-wrapper .custom-video-container');
    videoWrapper?.querySelector('.play__button')?.click();
    const videoElement = videoWrapper?.querySelector('video');
    videoElement?.play();
  }

  document.querySelectorAll('[data-product-accordion] a[href="#size__chart"]').forEach(ele => {
    ele.addEventListener('click', event => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const type = document.querySelector('[data-modal-opener="new-size-guide-popup"]');

      document.querySelector('#new-size-guide-popup .modal')?.classList.add('open');
      if (type?.getAttribute('data-main-type') === 'bottom') {
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-underwear"]')?.classList.add('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-bralettes"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-tank-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-bottom"]')?.classList.remove('open')
      } else if (type?.getAttribute('data-main-type') === 'top') {
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-bralettes"]')?.classList.add('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-tank-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-underwear"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-bottom"]')?.classList.remove('open')
      } else if (type?.getAttribute('data-main-type') === 'swim-top') {
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-top"]')?.classList.add('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-tank-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-underwear"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-bralettes"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-bottom"]')?.classList.remove('open')
      } else if (type?.getAttribute('data-main-type') === 'swim-bottom') {
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-bottom"]')?.classList.add('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-tank-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-underwear"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-bralettes"]')?.classList.remove('open')
      } else {
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-tank-top"]')?.classList.add('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-bralettes"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-underwear"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-top"]')?.classList.remove('open')
        document.querySelector('[data-new-size-guide-tabs] [data-style-tab="size-guide-swim-bottom"]')?.classList.remove('open')
      }
    })
  })
});

async function fetchSiblingProducts() {
  // Step 1: Collect all unique collection handles
  let allCollectionHandles = [...new Set(
    Array.from(document.querySelectorAll('[data-collection-handle]'))
      .map(ele => ele.getAttribute('data-collection-handle'))
  )];

  // Step 2: Initialize collections JSON object
  const collectionsJson = {};

  // Step 3: Fetch sibling products for each unique collection handle
  for (const collectionHandle of allCollectionHandles) {
    const formattedCollectionHandle = collectionHandle
      .replaceAll('_', '-')
      .replace('mix-pack', 'mixpack');

    // Assuming `useQuery` is an async function
    const siblingProducts = await useQuery(
      PRODUCT_SWATCHES_QUERY.replaceAll("{{collection_handle}}", formattedCollectionHandle)
    );

    // Step 4: Assign fetched sibling products to the collections JSON
    collectionsJson[collectionHandle] = siblingProducts;
  }

  console.log(collectionsJson);
}

// Call the async function
fetchSiblingProducts().catch(console.error);

class ProductTabGroup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initTabs();
  }

  initTabs() {
    const tabs = this.querySelectorAll(".tab");
    const productForm = this.closest('product-form');
    const savedTab = productForm ? (productForm.getAttribute('selected-color-tab') || '0') : '0';
    const activeTabIndex = parseInt(savedTab);

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", (e) => {
        e.preventDefault();
        tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");
        this.toggleColorSections(index);
      });

      if (index === activeTabIndex) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    });

    if (tabs.length > 0) {
      this.toggleColorSections(activeTabIndex);
    }
  }

  toggleColorSections(activeTabIndex) {
    let productForm = this.closest('product-form');

    if (!productForm) return;
    switch (activeTabIndex) {
      case 0:
        console.log('clicked 0')
        productForm.setAttribute('selected-color-tab', 0)
        break;
      case 1:
        console.log('clicked 1')
        productForm.setAttribute('selected-color-tab', 1)
        break;
      case 2:
        console.log('clicked 2')
        productForm.setAttribute('selected-color-tab', 2)
        break;
      default:
        console.log('clicked default')
    }
  }
}

customElements.define("product-tab-group", ProductTabGroup);